'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Message = require('./Message');

var _Message2 = _interopRequireDefault(_Message);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validator = function () {
  function Validator() {
    _classCallCheck(this, Validator);

    this.__isCached = true;
  }

  _createClass(Validator, [{
    key: 'createMessage',


    /**
     * Validator.createMessage wrapper for using in object context
     * @param {string} message
     * @param {{}} bindings
     * @returns {Message}
     */
    value: function createMessage(message, bindings) {
      return Validator.createMessage(message, bindings);
    }

    /**
     * Validate the value
     * @param {*} value
     * @param {string} attribute
     * @param {Model} model
     * @returns {Promise.<T>}
     */

  }, {
    key: 'validate',
    value: function validate(value, attribute, model) {
      return Promise.resolve();
    }

    /**
     * Is the validator safe?
     * @returns {boolean}
     */

  }, {
    key: 'isSafe',
    value: function isSafe() {
      return true;
    }

    /**
     * Compare validators
     * @param {Validator} a
     * @param {Validator} b
     * @returns {boolean}
     */

  }, {
    key: 'cache',


    // behavior modifiers
    /**
     * Enable/disable caching
     * @param bool
     * @returns {Validator}
     */
    value: function cache(bool) {
      this.__isCached = bool;

      return this;
    }

    /**
     * Ignore disabled cache behavior in milliseconds period
     * @param milliseconds
     * @returns {Validator}
     */

  }, {
    key: 'duration',
    value: function duration(milliseconds) {
      if (milliseconds) {
        this.__getTrueValue = this.throttledTrueValue(milliseconds);
      } else {
        this.__getTrueValue = undefined;
      }

      return this;
    }

    // valueObject interface implementation

  }, {
    key: 'equals',
    value: function equals(other) {
      if (this.hashCode() === other.hashCode()) {
        var isCached = this.__isCached && other.__isCached,
            getTrueValue = this.__getTrueValue || other.__getTrueValue;

        return isCached ? true : getTrueValue ? getTrueValue() : false;
      }
      return false;
    }
  }, {
    key: 'throttledTrueValue',
    value: function throttledTrueValue(duration) {
      var isThrottled = false;

      return function () {
        if (!isThrottled) {
          isThrottled = true;

          setTimeout(function () {
            isThrottled = false;
          }, duration);

          return false;
        }
        return true;
      };
    }

    /**
     * Generate hash code for the validator comparing
     * @returns {*}
     */

  }, {
    key: 'hashCode',
    value: function hashCode() {
      if (this.__hash) {
        return this.__hash;
      }
      var props = {};

      var exclude = /^__/;

      Object.entries(this).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        if (!exclude.test(k)) {
          props[k] = v;
        }
      });

      var map = new _immutable.Map(props);

      return this.__hash = map.hashCode();
    }
  }], [{
    key: 'createMessage',

    /**
     * Message instance creator
     * @param {string} message
     * @param {{}} bindings
     * @returns {Message}
     */
    value: function createMessage(message, bindings) {
      return new _Message2.default(message, bindings);
    }
  }, {
    key: 'is',
    value: function is(a, b) {
      if (a === b) return true;

      if (a instanceof Validator && b instanceof Validator && a.constructor === b.constructor) {
        return a.equals(b);
      }

      return false;
    }
  }]);

  return Validator;
}();

exports.default = Validator;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/validators/Validator.js
// module id = 18
// module chunks = 0